import React from 'react'
import {Box, MenuItem} from '@chakra-ui/react'
import PropTypes from 'prop-types'

export const RemoveMenuRole = ({role, propagateAs = 'button', type, ...props}) => {
    return <Box as={propagateAs} {...props} />
}

RemoveMenuRole.propTypes = {
    role: PropTypes.string,
    type: PropTypes.string,
    propagateAs: PropTypes.elementType
}

const StokkeMenuItem = ({as, ...props}) => {
    return <MenuItem {...props} as={RemoveMenuRole} propagateAs={as} />
}

StokkeMenuItem.propTypes = {
    as: PropTypes.elementType
}

export default StokkeMenuItem
